<template>
  <v-app>
    <GlobalLoader />
    <SwSnackbarHost />
    <v-main class="app-main-root">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import GlobalLoader from "@/components/Extras/GlobalLoader.vue";
import SwSnackbarHost from "@/components/Extras/SwSnackbarHost.vue";

export default {
  name: "App",

  components: {
    GlobalLoader,
    SwSnackbarHost,
  },
};
</script>
<style>
@import "@/assets/styles/sw-theme-tokens.css";
@import "@/assets/styles/sw-responsive.css";
@import "@/assets/styles/sw-fields.css";
@import "@/assets/styles/sw-float-field.css";
@import "@/assets/styles/sw-filter-panel.css";
@import "@/assets/styles/sw-buttons.css";
@import "@/assets/styles/page-content-header.css";
@import "@/assets/styles/sw-search-field.css";
@import "@/assets/styles/sw-table-layout.css";
@import "@/assets/styles/sw-data-table.css";
@import "@/assets/styles/tickets-page.css";
@import "@/assets/styles/sw-dialogs.css";
@import "@/assets/styles/sw-overlays.css";
@import "@/assets/styles/sw-status-chips.css";
@import "@/assets/styles/report-detail.css";
@import "@/assets/styles/dashboard.css";
@import "@/assets/styles/sw-date-picker.css";
@import "@/assets/styles/sw-time-picker.css";
@import "@/assets/styles/sw-performance.css";
@import "@/assets/styles/create-ticket-wizard.css";
@import "@/assets/styles/rfs-create-ticket-form.css";
@import "@/assets/styles/schedule-service-create.css";
@import "@/assets/styles/sw-segmented-control.css";
@import "@/assets/styles/ticket-details.css";
@import "@/assets/styles/customer-details-tabs.css";
@import "@/assets/styles/customers-page.css";
@import "@/assets/styles/approval-detail-dialog.css";
@import "@/assets/styles/approvals-page.css";
@import "@/assets/styles/approval-component-queue.css";
@import "@/assets/styles/sw-map-form-layout.css";
@import "@/assets/styles/tad-field.css";
@import "@/assets/styles/ticket-action-dialog.css";
@import "@/assets/styles/fgr-approve-dialog.css";
@import "@/assets/styles/fgr-info-dialog.css";
@import "@/assets/styles/sw-snackbar.css";
@import "@/assets/styles/sw-avatar.css";
@import "@/assets/styles/app-bar-controls.css";
@import "@/assets/styles/org-settings-hub.css";
@import "@/assets/styles/org-settings-dropdown.css";
@import "@/assets/styles/sw-theme-dark.css";
@import "@/assets/styles/sw-text-rendering.css";

/* Match Chrome ~77% zoom at browser 100% — UI density only, no logic impact */
html {
  zoom: 0.9;
}

html,
body,
#app {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--app-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.v-application {
  height: 100%;
  overflow: hidden;
  font-family: var(--app-font-family) !important;
}

.app-main-root {
  height: 100%;
  overflow: hidden;
  padding: 0 !important;
}

:root {
  --app-font-family: "DM Sans", system-ui, -apple-system, "Segoe UI", Roboto,
    Helvetica, Arial, sans-serif;
  --app-font-display: "Sora", var(--app-font-family);
  --panel-radius: 24px;
}

.PrimaryFontColorSmall,
.btn {
  color: var(--sw-primary) !important;
}

/* Field typography — see sw-fields.css */
.fontsize16px {
  font-size: 16px !important;
}
.xsmallFontSize {
  font-size: 12px !important;
  margin-left: 16px;
}
.tableTextWidth {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 50px;
}
.WidthVariation1 {
  max-width: 200px !important;
}
.WidthVariation2 {
  max-width: 150px !important;
}
.widthSmall {
  max-width: 120px !important;
}
.PrimaryFontColor {
  color: 42424;
  font-size: 20px !important;
}
.PrimaryFontColorSmall {
  font-size: 15px !important;
}
.btn {
  padding: 30;
  font-size: 30px;
}
.heading1 {
  font-size: 30px;
}
.heading3 {
  font-size: 20px;
}
.heading2 {
  font-size: 16px;
  color: #1c1c1c;
}
.smallwidth {
  max-width: 100px !important;
}
.mediumWidth {
  max-width: 180px !important;
}
.smallFontSize {
  font-size: 15px;
}
.FontSize10px {
  font-size: 10px !important;
}
.PrimaryFontColorSmall {
  color: #3d3d3d;
  font-size: 15px;
}
.PrimaryFontColorXSmall {
  color: #3d3d3d;
  font-size: 12px;
}
.xlargeFontSize {
  font-size: 30px;
  color: #3d3d3d;
  line-height: 35px;
}

.largeFontSize {
  font-size: 40px;
  color: #3d3d3d;
  line-height: 50px;
  font-weight: bold;
  margin: 0;
}
.largeFontSizeNew {
  font-size: clamp(1.125rem, 1.6vw, 1.3125rem);
  color: var(--sw-text);
  line-height: 1.25;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.02em;
}
.FontSize10px {
  font-size: 10px !important;
}
.xmediumFontSize {
  font-size: 20px;
  color: #3d3d3d;
}
.xmediumFontSizeRed {
  font-size: 20px;
  color: red;
  font-weight: lighter;
}
.largeFontSizeRed {
  font-size: 30px;
  color: red;
}
.largeFontSizePrimary {
  font-size: 30px;
  color: #3d3d3d;
}
.largeFontSizePrimaryGreen {
  font-size: 30px;
  color: green;
}
.largeFontSizePrimaryOrange {
  font-size: 30px;
  color: orange;
}
.mediumFontSize {
  font-size: 25px;
  line-height: 30px;
  color: #3d3d3d;
}
.paddingTop {
  padding-top: 130px;
}
.borderRadius {
  border-radius: 20px !important;
}
/* Label sizing — see sw-fields.css */
.field_height.v-text-field .v-input__control .v-input__slot {
  min-height: 12px !important;
  display: flex !important;
  align-items: center !important;
}
.field_label_size .v-input .v-label {
  font-size: 12px;
}
.v-select
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  padding: 0 !important;
  min-height: 0 !important;
}

.v-select-list .v-list-item {
  min-height: 0 !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 14px 0 !important;
}
.borderRadius {
  border-radius: 20px !important;
}
.theme--light.v-divider {
  border-color: #909090 !important;
  height: 100px;
}
.FontSize {
  font-size: 12px !important;
  line-height: 2.5 !important;
}
.BorderPrimary {
  border: 2px dashed #3d3d3d !important;
}
.BorderRed {
  border: 2px dashed red !important;
}
.BorderGreen {
  border: 2px dashed green !important;
}
.BorderOrange {
  border: 2px dashed orange !important;
}
.GreenHeader {
  color: green;
}
.RedHeader {
  color: red;
}
.BlackHeader {
  color: black;
  font-weight: bold;
}
.BlueHeader {
  color: blue;
}
.OrangeHeader {
  color: orange;
}
.YellowHeader {
  color: black;
}
.maxWidth {
  max-width: 250px !important;
}
.maxWidthSmall {
  max-width: 180px !important;
}
.maxWidthXSmall {
  max-width: 120px !important;
}
.maxWidth80px {
  max-width: 90px !important;
}
.BorderOutline {
  border: 1px solid black !important;
}
.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.excel-upload-input {
  display: none;
  z-index: -9999;
}

.ContactStyle {
  font-size: 30px !important;
  color: grey !important;
}
.fontsize20px {
  font-size: 20px !important;
}
.fontsize15px {
  font-size: 15px !important;
}
.CardBorderClass {
  border: 2px solid black !important;
}
.TableValFontsize td {
  font-size: 12px !important;
}
.DashedCard {
  border: 2px dashed var(--sw-primary) !important;
}
.DashedCard1 {
  border: 2px solid var(--sw-primary) !important;
}

.v-data-table-header__content {
  font-size: 14px !important;
  font-weight: bolder !important;
}
.pac-container {
  z-index: 3000 !important;
  font-family: var(--app-font-family) !important;
}
</style>
